export default "__VITE_ASSET__lKIrUAFd__"